import { createContext } from "react";
import { initialControlTarget } from "../init";

const ControlTargetContext = createContext(initialControlTarget);

export default ControlTargetContext;
